module.exports = __webpack_public_path__ + "static/media/clueMM-thumb.8ee4e2fc.png";